import React from "react";
import ComparableGrid from "components/Homeowner/CaseForms/ComparableGrid/ComparableGrid";
import { CardText, Card } from "react-md";
class NewCompGridDemo extends React.Component {
  render() {
    return (
      <Card>
        <CardText>
          <ComparableGrid controlNumber={13862326} isDemo={true} />
        </CardText>
      </Card>
    );
  }
}

export default NewCompGridDemo;
